export enum MATERIAL_PARAMS {
    CLASS_GRADES = 'classGrades',
    MATERIAL_TYPES = 'materialTypes',
    SUBJECT = 'subject',
    TOP_SUBJECT = 'topSubject'
}

export type ExtractedMaterialDetails = MaterialClassGrade[] | MaterialCategory[] | MaterialType[];

const extractMaterialDetails = (param: string, extractedMaterialDetails: ExtractedMaterialDetails) => {
    let arr = [] as string[];
    const data = extractedMaterialDetails || [];

    if (param === MATERIAL_PARAMS.MATERIAL_TYPES || param === MATERIAL_PARAMS.CLASS_GRADES) {
        data.forEach((item) => arr.push(item.title));
    } else if (param === MATERIAL_PARAMS.SUBJECT) {
        const titles = {};

        data.forEach((item) => {
            // @ts-ignore
            titles[item.fullPathWithLandingPages[0].title] = item.fullPathWithLandingPages[0].title;
        });
        arr = Object.keys(titles);
    } else if (param === MATERIAL_PARAMS.TOP_SUBJECT) {
        arr = data.map((category: { title: string }) => category.title);
    }

    return arr.join(', ');
};

export default extractMaterialDetails;
